import React from "react";
import logo from "../media/logo.png";
import Float from "../ui/Float";
import Space from "../ui/Space";
import Label from "../ui/Label";
import ConsoleClockPing from "./ConsoleClockPing";
import { useSignal, useSignals } from "@preact/signals-react/runtime";
import { useGlobals } from "../hooks/Globals";
import StoreSelector from "./StoreSelector";
import { kbdEvent } from "../utils/Utils";
import { KBD } from "../utils/Keybindings";
export default function ConsoleHeader(props) {

    useSignals();
    const { signal = {}, title = "", is_modal = false } = props;
    const _title = (title) ? title : signal?.value?.title;
    const _clerk_code = (signal?.value?.session?.clerk_code) ? signal?.value?.session?.clerk_code : ""
    const _clerk_name = (signal?.value?.session?.clerk_name) ? signal?.value?.session?.clerk_name : ""
    const _station = (signal?.value?.session?.station) ? signal?.value?.session?.station : ""
    const show_back = signal?.value?.show_back || false;
    return (
        <div className="console-header" style={{ "padding": "0px 15px" }}>
            <div style={{ "height": "40px", "display": "flex", "justifyContent": "space-between", "alignItems": "center" }}>
                <div>
                    <Space style={{ "alignItems": "center" }} size={6}>
                        {(!is_modal && !show_back && <div><img style={{ "height": "15px" }} src={logo} /></div>)}
                        {((is_modal || show_back) && <div style={{"marginLeft" : "-8px"}}><kbd onClick={() => kbdEvent(KBD.ESCAPE)}><small>← Back</small></kbd></div>)}
                        {(!is_modal && !show_back && <div><Space><div></div><div style={{ borderLeft: "1px solid var(--border-primary)", "marginTop": "-4px", "height": "22px" }}></div><div></div></Space></div>)}
                        <div style={{ "fontSize": "14px" }} className="hotkey">{_title}</div>
                    </Space>
                </div>
                <div>
                    <StoreSelector />
                </div>
                <div>
                    <Space style={{ "alignItems": "center" }} size={10}>
                        <ConsoleClockPing />
                        <div style={{ borderLeft: "1px solid var(--border-primary)", "marginTop": "-4px", "height": "22px" }}></div>
                        <Label><em>No New Messages</em></Label>
                        <div style={{ borderLeft: "1px solid var(--border-primary)", "marginTop": "-4px", "height": "22px" }}></div>
                        <Label className="bold" style={{ "color": "var(--text-red)" }}>2 Online Orders</Label>
                        <div style={{ borderLeft: "1px solid var(--border-primary)", "marginTop": "-4px", "height": "22px" }}></div>
                        <Label className="bold" >#{_station} {_clerk_code}{(_clerk_name && ` (${_clerk_name})`)}</Label>
                    </Space>
                </div>
            </div>
        </div>
    )
}